import Reveal from "@/components/feature/Reveal";
import { timelineItems } from "@/mocks/homeTimeline";
import { tagClass } from "@/pages/home/tagStyles";

const methodSteps = [
  { id: "step-1", icon: "ri-file-search-line", title: "先看类型", desc: "按截图、录音、文件分区进入" },
  { id: "step-2", icon: "ri-links-line", title: "再对时间", desc: "用时间戳核对前后顺序" },
  { id: "step-3", icon: "ri-discuss-line", title: "最后讨论", desc: "把疑问写进讨论区一起核" },
];

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-6">
            <span className="text-xs font-medium tracking-widest text-accent-700">TIMELINE</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              线索细节时间线
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              每次整理都会留下记录：什么时候补了哪段材料、哪条细节被核对过，按时间往下读，前后变化一眼就能看清。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-8">
            <ol className="relative border-l border-background-300 pl-6">
              {timelineItems.map((item) => (
                <li key={item.id} className="relative pb-7 last:pb-0">
                  <span className="absolute -left-[31px] top-1.5 flex h-2.5 w-2.5 items-center justify-center rounded-full bg-primary-500 ring-4 ring-background-50"></span>
                  <div className="flex flex-wrap items-center gap-2.5">
                    <span className="font-heading text-sm font-bold text-foreground-950">
                      {item.date}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span
                      className={`rounded-md px-2 py-0.5 text-xs font-medium ${tagClass(item.tag)}`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="mt-2 text-base font-medium text-foreground-900">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </li>
              ))}
            </ol>
          </Reveal>

          <Reveal className="lg:col-span-4" delay={80}>
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">怎么核对更省事</h3>
              <ul className="mt-4 flex flex-col gap-4">
                {methodSteps.map((step, index) => (
                  <li key={step.id} className="flex gap-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-50 text-secondary-700">
                      <i className={`${step.icon} text-lg`}></i>
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">
                        <span className="mr-1.5 text-xs text-foreground-400">0{index + 1}</span>
                        {step.title}
                      </p>
                      <p className="mt-0.5 text-xs leading-relaxed text-foreground-600">
                        {step.desc}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="mt-5 rounded-md bg-accent-50 p-4">
                <p className="text-xs leading-relaxed text-accent-900">
                  <i className="ri-information-line mr-1 align-middle"></i>
                  时间线会保留旧版本记录，方便你对照前后说法差异，不会覆盖历史内容。
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}